import { render, staticRenderFns } from "./ResellerPackages.vue?vue&type=template&id=1ef55419&"
import script from "./ResellerPackages.vue?vue&type=script&lang=js&"
export * from "./ResellerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports